import firebase from "firebase/app";

export const targetCollectionKey = "targets";

/** スクール領域「塾」の targets.key */
export const CRAM_SCHOOL_TARGET_KEY = "cram_school";

export type Target = {
  ref: firebase.firestore.DocumentReference;
  data: TargetData;
};

export type TargetData = {
  key: string;
  name: string;
};

export function convertToTarget(
  data: firebase.firestore.DocumentData,
  ref: firebase.firestore.DocumentReference
): Target {
  const returnData: TargetData = {
    key: data.key,
    name: data.name
  };

  return {
    ref,
    data: returnData
  };
}
